import React, { useEffect, useState } from 'react';
import useHttp from '../../../hooks/use-http';
import Inputs from './components/Inputs';
import GridProvider from './components/GridProvider';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import { isFormValid } from './validation/isFormValid';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import { useTranslation } from 'react-i18next';
import { urls } from './api/urls';

const INITIAL_VALUES = {
  id: 0,
  idTipaMasine: 0,
  naziv: '',
  opis: '',
  idKategorije: null,
  nazivKategorije: '',
  nazivTipaMasine: '',
  metadata: '',
  idKorProm: +localStorage.idKorisnika,
};

const KategorijeDokumenata = ({ save, handleSave, novi, handleNovi }) => {
  const { t, i18n } = useTranslation();
  const [formValues, setFormValues] = useState(INITIAL_VALUES);
  const { sendRequest, getData, data, isLoading } = useHttp('');
  const { sendRequest: vratiMasine, data: masineData } = useHttp('');
  const { sendRequest: vratiKategorije, data: kategorijeData } = useHttp('');
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  useEffect(() => {
    const configMasine = {
      url: urls.GET_MASINE_COMBO,
      method: 'POST',
      data: { metadata: i18n.language },
    };
    vratiMasine(configMasine);
  }, []);

  const vratiKategorijeData = () => {
    const configMasine = {
      url: urls.GET_DATA,
    };
    vratiKategorije(configMasine);
  };
  useEffect(() => {
    vratiKategorijeData();
  }, []);

  const handleOpenDeleteDialog = (id) => {
    setOpenDeleteDialog(true);
    setFormValues({ ...INITIAL_VALUES, id: id });
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_DATA,
      data: {
        id: formValues.id,
      },
    };
    const result = await getData(config);
    if (result > 0) {
      vratiKategorijeData();
      setOpenDeleteDialog(false);
      setFormValues(INITIAL_VALUES);
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  const handleEditData = async (item) => {
    setFormValues((curr) => {
      return { ...curr, ...item, naziv: item.oznaka };
    });
  };
  const handleSaveData = async () => {
    if (isFormValid(formValues)) {
      return;
    }
    const config = {
      method: 'POST',
      url: formValues.id !== 0 ? urls.IZMENA_DATA : urls.UNOS_DATA,
      data: {
        id: formValues.id,
        oznaka: formValues.naziv,
        opis: formValues.opis,
        metadata: formValues.metadata,
        idKategorije: formValues.idKategorije,
        idTipaMasine: formValues.idTipaMasine,
      },
    };
    const result = await getData(config);
    if (result.rezultat > 0) {
      vratiKategorijeData();
      setFormValues(INITIAL_VALUES);
      toast.success(t('dataAddedSuccessfully'));
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);
  useEffect(() => {
    if (novi) {
      setFormValues(INITIAL_VALUES);
      handleNovi(false);
    }
  }, [novi]);
  return (
    <div>
      <Inputs
        formValues={formValues}
        setFormValues={setFormValues}
        masine={masineData}
      />
      <GridProvider
        data={kategorijeData}
        handleEditData={handleEditData}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => {
          setOpenDeleteDialog(false);
          setFormValues(INITIAL_VALUES);
        }}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default KategorijeDokumenata;
